import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { forkJoin, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { PictureData } from "src/app/annotation/canvas/canvas.component";
import { PhotoIndexInfo } from "src/app/shared/Models/interfaces/PhotoIndexInfo.interface";
import { Survey } from "src/app/shared/Models/read/Survey";
import { ToastService } from "src/app/shared/toast.service";
import { FrameListService } from "../../inside-survey/services/frameList.service";
import { BuildingService } from "src/app/core/building-list/services/building.service";
import {
  PhotoViewmodel,
  PictureInfo,
} from "../../shared/components/photo-and-remark/photo-viewmodel";
import {
  FIELD_OUTSIDE_PHOTOS_FACADE_PHOTO,
  OUTSIDE_SURVEY_PHOTOS,
  SUBTITLE_OUTSIDE_PHOTOS_FACADE_PHOTO,
} from "../config/outside-survey.magic-strings";
import { FormValidationService } from "../../shared/services/formValidation.service";
import { FormErrorsPhoto } from "./form-errors-photo.model";
import { OutsideSurveyPhotoFormComponent } from "./outside-survey-photo-form/outside-survey-photo-form.component";
import { BuildingTypeEnum } from "src/app/shared/Models/enums/BuildingTypeEnum";

@Component({
  selector: "app-outside-survey-photo",
  templateUrl: "./outside-survey-photo.component.html",
  styleUrls: ["./outside-survey-photo.component.scss"],
  providers: [ToastService],
})
export class OutsideSurveyPhotoComponent implements OnInit, AfterViewInit {
  tabId = OUTSIDE_SURVEY_PHOTOS;
  @Input() isAuthCanWrite: boolean;
  @Input() survey: Survey;
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  @ViewChildren(OutsideSurveyPhotoFormComponent)
  photosComp: QueryList<OutsideSurveyPhotoFormComponent>;

  viewmodel: PhotoViewmodel = {
    facadePhotos: [],
    detailPhotos: [],
    facadeComment: "",
    detailComment: [],
  };

  formErrors: FormErrorsPhoto = {
    facadePhoto: false,
  };

  get showOpenButton$() {
    return this.frameListService
      .anyOpen(...[...this.survey.building.addresses.map((a) => a.id)])
      .pipe(map((b) => !b));
  }

  openAllFrames() {
    this.frameListService.open(
      ...[...this.survey.building.addresses.map((a) => a.id)]
    );
  }

  closeAllFrames() {
    this.frameListService.close(
      ...[...this.survey.building.addresses.map((a) => a.id)]
    );
  }

  savedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };
  unsavedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };

  gotPhotoCallback: (data: PictureData) => void;

  constructor(
    private toastService: ToastService,
    private frameListService: FrameListService,
    private formValidationService: FormValidationService,
    private buildingService: BuildingService
  ) {}

  ngOnInit() {
    this.viewmodel = {
      facadePhotos: [...this.survey.photos.facadePhotos],
      detailPhotos: this.survey.photos.detailPhotos.map(
        (d) => new PictureInfo({ ...d })
      ),
      facadeComment: "",
      detailComment: [],
    };
    this.buildOrder();
    this.survey.building.addresses.forEach((a) =>
      this.formValidationService.addFormError([OUTSIDE_SURVEY_PHOTOS, a.id], {
        [SUBTITLE_OUTSIDE_PHOTOS_FACADE_PHOTO]: {
          [FIELD_OUTSIDE_PHOTOS_FACADE_PHOTO]: false,
        },
      })
    );
  }

  private buildOrder() {
    this.savedPhotoOrder.detailPhotos = this.unsavedPhotoOrder.detailPhotos =
      this.viewmodel.detailPhotos.map((s) => ({
        index: s.index,
        photoId: s.data.id,
      }));
  }

  ngAfterViewInit(): void {
    this.init();
  }

  toggleLayer(layer: HTMLDivElement) {
    layer.classList.toggle("hidden");
  }

  save(checkValidity?: boolean): Observable<any> {
    if (checkValidity && !this.isTabValid()) return of(false);

    if (!this.isAuthCanWrite) return of(true);

    return forkJoin(this.photosComp.map((comp) => comp.save())).pipe(
      map((res) => res.every((i) => i))
    );
  }

  private isTabValid() {
    this.formValidationService.resetErrorsForPath(OUTSIDE_SURVEY_PHOTOS);
    if (!this.isAuthCanWrite) return true;

    let isValid = true;
    let i = 1;
    let mainAddressId = this.survey.building.getMainAddress().id;
    let buildingtype = this.survey.building.buildingType;
    if (buildingtype == BuildingTypeEnum.NotInUse) return true;

    this.photosComp.forEach((component: OutsideSurveyPhotoFormComponent) => {
      if (
        component.address.id === mainAddressId &&
        component.viewmodel.facadePhotos.length === 0
      ) {
        isValid = false;
        this.formValidationService.addError(
          OUTSIDE_SURVEY_PHOTOS,
          component.address.id,
          SUBTITLE_OUTSIDE_PHOTOS_FACADE_PHOTO,
          FIELD_OUTSIDE_PHOTOS_FACADE_PHOTO
        );
      }
      i++;
    });

    if (!isValid)
      this.toastService.showWarnToast(
        $localize`:@@general.warning:Warning`,
        $localize`:@@validation.survey.onefacadephotoforeachaddress:At least 1 facade photo is required for each main address`
      );

    return isValid;
  }

  resetErrors() {
    this.formErrors.facadePhoto = false;
  }

  private init() {}
}
